import {
  ExternalCardFragment,
  tag,
} from 'services/graphql/fragments/Fragments';
import { AnalyticsEventFragment } from 'services/graphql/fragments/HomeTilesContentFragment';
import { gql } from 'urql';

const FetchExternalCards = gql`
  query GetExternalCards {
    externalCards {
      __typename
      ... on ExternalCardsError {
        __typename
        code
        errorMessage: message
        errorTitle: title
      }
      ... on ExternalCardsNotFound {
        __typename
        image
        message
        title
        notFoundButton: button {
          __typename
          buttonText
          buttonStyle
          buttonOnClick {
            __typename
            ... on RouteNavigationAction {
              __typename
              route
              analyticsEvent {
                ...AnalyticsEventFragment
              }
            }
          }
        }
      }
      ... on ExternalCardsSuccess {
        __typename
        id
        button {
          __typename
          buttonText
          buttonStyle
          buttonOnClick {
            __typename
            ... on RouteNavigationAction {
              __typename
              route
              analyticsEvent {
                ...AnalyticsEventFragment
              }
            }
          }
        }
        externalCard {
          ...ExternalCardFragment
          tag {
            ...tag
          }
        }
      }
    }
  }
  ${ExternalCardFragment}
  ${tag}
  ${AnalyticsEventFragment}
`;

export default FetchExternalCards;
